import React from 'react'
import classnames from 'classnames'

import useHeader from '../../hooks/useHeader'

import styles from '../../styles/components/Header/HeaderClose.module.css'

const HeaderClose = () => {
  const header = useHeader()
  const closeClassName = classnames(styles.close, {
    [styles.closeActive]: header.isMenuOpen
  })

  return (
    <button aria-label='Fechar menu' onClick={header.onToggleClick} className={closeClassName}>
      <img src='close.svg' alt='' />
    </button>
  )
}

export { HeaderClose }
